<template>
  <SplitContent
          :i18n="true"
          :menus="menus"
          @changeItem="changeItem"
          :defaultValue="defaultSelected"
          :isReady="isReady"
  >
    <template slot="right">
      <div class="main-con" id="black-main">

        <!--产品类型-->
        <template v-if="currentMenu.value === 'page_product_type'">
          <ProductType/>
        </template>

        <!--产品-->
        <template v-if="currentMenu.value === 'page_product_maintenance'">
          <Product/>
        </template>

        <!--单据设置-->
        <template v-if="currentMenu.value === 'page_bill_settings'">
          <billSettings :menuId="currentMenu.id"/>
        </template>

        <!--字段设置-->
        <template v-if="currentMenu.value === 'page_business_field_setting'">
          <fieldSetting :menuId="currentMenu.id"/>
        </template>

        <!--物料类型-->
        <template v-if="currentMenu.value === 'page_business_material_type'">
          <MaterialType style="padding: 8px 8px 0 0;"/>
        </template>

        <!--物料信息-->
        <template v-if="currentMenu.value === 'page_business_material_info'">
          <MaterialInfo style="padding: 8px 8px 0 0;"/>
        </template>

        <!--库区库位-->
        <template v-if="currentMenu.value === 'page_business_reservoir_location'">
          <ReservoirLocation/>
        </template>

        <!--出库类型-->
        <template v-if="currentMenu.value === 'page_business_delivery_type'">
          <DeliveryType style="padding: 8px 8px 0 0;"/>
        </template>

        <!--入库类型-->
        <template v-if="currentMenu.value === 'page_business_warehousing_type'">
          <WarehousingType style="padding: 8px 8px 0 0;"/>
        </template>

        <!--设备类型-->
        <template v-if="currentMenu.value === 'page_business_device_type'">
          <DeviceType/>
        </template>

        <!--故障类型-->
        <template v-if="currentMenu.value === 'page_business_fault_type'">
          <FaultType style="padding: 8px 8px 0 0;"/>
        </template>

        <!--点检项目-->
        <template v-if="currentMenu.value === 'page_tpm_check_project_name'">
          <SpotCheck/>
        </template>

        <!--保养-->
        <template v-if="currentMenu.value === 'page_business_maintenance_program'">
          <MaintenanceProgram/>
        </template>

        <!--报废类型-->
        <template v-if="currentMenu.value === 'page_scrap_type'">
          <ScrapType/>
        </template>
        <!-- 安灯呼叫类型 -->
        <template v-if="currentMenu.value === 'page_business_andon_type'">
          <call-out-type/>
        </template>
      </div>
    </template>
  </SplitContent>
</template>

<script>
import Product from './Product/Product.vue'
import ProductType from './ProductType/ProductType.vue'
import billSettings from '../bill-settings/index'
import fieldSetting from './fieldSetting/index'
import MaterialType from './MaterialType/index'
import DeliveryType from './DeliveryType/index'
import WarehousingType from './WarehousingType/index'
import MaterialInfo from './MaterialInfo/index'
import ReservoirLocation from './ReservoirLocation/index'
import SpotCheck from './SpotCheck/index.vue'
import DeviceType from './DeviceType/index'
import MaintenanceProgram from './MaintenanceProgram/index'
import FaultType from './FaultType/index'
import { MasterlinkRoleServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import ScrapType from './ScrapType/index.vue'
import CallOutType from './callOutType/index.vue'
import { getLocalStorage } from '@/utils/storage'
import { mapGetters } from 'vuex'

const masterlinkRoleServiceProxy = new MasterlinkRoleServiceProxy()

export default {
  components: {
    Product,
    ProductType,
    MaterialType,
    DeliveryType,
    WarehousingType,
    MaterialInfo,
    ReservoirLocation,
    SpotCheck,
    DeviceType,
    MaintenanceProgram,
    FaultType,
    ScrapType,
    billSettings,
    CallOutType,
    fieldSetting
  },
  data () {
    return {
      menus: [],
      currentMenu: {},
      defaultSelected: {},
      isReady: true,
      currentPath: '',
      currentMenuId: [],
      menuIdMaps: []
    }
  },
  watch: {
    appRoutes: { // 获取菜单路径和菜单id映射关系
      handler (val) {
        let temp = {}
        const getIdFn = (data) => {
          data.map(item => {
            if (item.hasOwnProperty('id') && item.hasOwnProperty('path')) {
              temp[item.id] = item.path
            }
            if (item.hasOwnProperty('children')) {
              getIdFn(item.children)
            }
          })
        }
        getIdFn(val)
        // console.log('路径id映射：', temp)
        this.menuIdMaps = temp
      },
      deep: true,
      immediate: true
    },
    '$route.path': { // 根据当前路由获取id
      handler (val) {
        let id = Object.keys(this.menuIdMaps).find(key => this.menuIdMaps[key] === val)
        this.currentMenuId = id
        this.getMenus()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['appRoutes'])
  },
  created () {
    const isQuality = getLocalStorage('Quality')
    if (isQuality === 'quality') {
      this.isReady = false
    } else {
      this.isReady = true
    }
    if (isQuality === 'quality') {
      const item = {
        label: 'page_product',
        value: 'page_product'
      }
      this.defaultSelected = item
    } else {
      let type = this.$route.params.type ? this.$route.params.type : ''
      if (type) {
        this.defaultSelected = this.menus.map((item) => item.value === type)
      } else {
        this.defaultSelected = this.menus[0]
      }
    }
  },
  methods: {
    async getMenus () {
      const menus = await masterlinkRoleServiceProxy.getAvailableDynamicMenus(this.currentMenuId)
      const treeNodes = menus.data.treeNodes
      let temp = []
      treeNodes.map((item) => {
        temp.push({ label: item.attribute.code, value: item.attribute.code, id: item.id })
      })
      this.menus = temp
    },
    changeItem (item) {
      this.currentMenu = item
      this.currentPath = this.$route.path
    }
  }
}
</script>

<style scoped lang="less">
  .main-con {
    width: 100%;
    height: 100%;

    .title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      padding-bottom: 16px;
      border-bottom: 1px solid #e8e8e8;
      line-height: 24px;
    }

    /deep/ .main {
      box-shadow: unset !important;
    }
  }

  /deep/ .ant-menu-item {
    margin: 0 !important;
  }

  /deep/ .ant-menu-item:first-child {
    margin-top: 0px !important;
  }

  /deep/ .ant-menu-item::after {
    border-right-color: transparent !important;
  }

  /deep/ .ant-menu-item-selected {
    background-color: #4a90e2 !important;
    color: #fff;
  }

</style>
